export default __webpack_public_path__ + "media/Non-food-Tissue-Tissue-Dispenser.8e73ddb2.png";